import { render } from "./NewsView.vue?vue&type=template&id=23fe6ec8&scoped=true"
const script = {}

import "./NewsView.vue?vue&type=style&index=0&id=23fe6ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fe6ec8"]])

export default __exports__